import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=c5ddd450&scoped=true&"
import script from "./LostPassword.vue?vue&type=script&lang=ts&"
export * from "./LostPassword.vue?vue&type=script&lang=ts&"
import style0 from "./LostPassword.vue?vue&type=style&index=0&id=c5ddd450&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ddd450",
  null
  
)

export default component.exports